import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useSessionUuid } from '#src/app/shared/hooks/session';
import type { ShareLink } from '#src/app/shared/hooks/share';

import { usePromotedTrackingDataWithQueryParams } from '../usePromotedTrackingDataWithQueryParams';

import { getPetitionShareLinks } from './api';

const QUERY_KEY = 'petition-share-links';

export type PetitionShareLinksResult = {
	links: readonly ShareLink[];
	isLoading: boolean;
};

export function usePetitionShareLinks(): PetitionShareLinksResult {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const utilityContext = useUtilityContext();
	const sessionUuid = useSessionUuid();
	const promotionToken = usePromotedTrackingDataWithQueryParams()?.token;

	const { data: queryData, isLoading } = useQuery({
		queryKey: [QUERY_KEY, { id, sessionUuid, promotionToken }],
		queryFn: async () => getPetitionShareLinks({ id, promotionToken, utilityContext }),
		staleTime: Infinity,
	});

	return { links: queryData ?? [], isLoading };
}
